import styled from 'styled-components'

export const Main = styled.div`
  margin: 0 -5px;
  display: flex;
  flex-direction: row;
`
